import { useCallback, useEffect, useState } from "react";
import { useMyRoles } from "@/hooks/useMyRoles";

const STORAGE_KEY = "tama-debug";

/** Lit la demande d'affichage (paramètre ?debug=1 ou mémoire de l'appareil). */
const readRequested = () => {
  try {
    if (new URLSearchParams(window.location.search).get("debug") === "1") {
      localStorage.setItem(STORAGE_KEY, "1");
      return true;
    }
    return localStorage.getItem(STORAGE_KEY) === "1";
  } catch {
    return false;
  }
};

/**
 * Panneau de diagnostic : réservé aux admins. La demande seule n'active rien
 * tant que le rôle admin n'est pas confirmé (lecture de user_roles).
 */
export const useDebugPanel = () => {
  const { isAdmin, isLoading } = useMyRoles();
  const [requested, setRequested] = useState(false);

  useEffect(() => {
    setRequested(readRequested());
  }, []);

  const close = useCallback(() => {
    try {
      localStorage.removeItem(STORAGE_KEY);
    } catch {
      /* stockage indisponible : on ferme simplement */
    }
    setRequested(false);
  }, []);

  return { enabled: requested && isAdmin && !isLoading, close };
};
